<template>
  <div class="comments-list">
    <slot name="comments"></slot>
  </div>
</template>

<script>
export default {
  name: "CommentList"
};
</script>

<style lang="scss">
.comments-list ol {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>